import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '../../conditional-rendering';

const Input = props => {
    const {
        label: { labelText, labelClasses, wrapperClasses, isRequired, ariaLabel },
        input: {
            id,
            name,
            inputClasses,
            placeholder,
            type,
            value,
            readOnly = false,
            maxLength,
            disabled,
            isInputRequired,
        },
        actions: { handleFieldChange, handleFieldBlur, handleFieldFocus },
        labelIcon = {},
    } = props;

    const handleValueChange = e => {
        handleFieldChange(e.target.value);
    };

    const handleValueBlur = e => {
        handleFieldBlur && handleFieldBlur(e.target.value);
    };

    const handleValueFocus = e => {
        handleFieldFocus && handleFieldFocus(e.target.value);
    };

    return (
        <Fragment>
            <div className={`gi-input ${wrapperClasses && wrapperClasses.join(' ')}`}>
                <label
                    htmlFor={id}
                    className={`gi-input__label ${labelClasses && labelClasses.join(' ')} required-${isRequired}`}
                    aria-label={ariaLabel}
                >
                    <ConditionalRendering isTrue={labelText}>
                        <FormattedMessage id={labelText} />
                    </ConditionalRendering>
                    {labelIcon.icon ? labelIcon.icon : null}
                </label>
                <input
                    id={id}
                    dataautomationid={id}
                    data-testid={id}
                    className={`gi-input__input ${inputClasses && inputClasses.join(' ')}`}
                    disabled={disabled}
                    name={name}
                    type={type}
                    value={value || ''}
                    readOnly={readOnly}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    onChange={handleValueChange}
                    onBlur={handleValueBlur}
                    onFocus={handleValueFocus}
                />
            </div>
            {/*<Error*/}
            {/*    isVisible={ isErrorVisible }*/}
            {/*    messageText={ messageText }*/}
            {/*    textReplacements={ textReplacements }*/}
            {/*    errorWrapperClasses={ errorWrapperClasses }*/}
            {/*    errorClasses={ errorClasses }*/}
            {/*/>*/}
        </Fragment>
    );
};

export default Input;
